export default class InfoNCVVN{
    constructor(_wrapper: HTMLElement) {
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        _parent.classList.add('footer-info-ncvvn');
        _parent.innerHTML= `
        <div class="footer-rating">
            <img src="https://assets.playnccdn.com/resource/lineage2mncv/footer-rating-vn.png">
        </div>
        <div class="footer-info-address">
CÔNG TY TNHH VNGGAMES<br>
Địa chỉ trụ sở: Tầng 2, Tòa nhà Saigon Paragon, số 3 Nguyễn Lương Bằng, Phường Tân Mỹ, Thành phố Hồ Chí Minh.<br>
Địa chỉ liên hệ: VNG Campus, Z06 đường số 13, Khu chế xuất Tân Thuận, phường Tân Thuận, Thành phố Hồ Chí Minh.<br>
Điện Thoại: 1900 561 558<br>
<br>
Giấy phép cung cấp dịch vụ trò chơi điện tử G1 trên mạng số 146/GP-PTTH&TTĐT do Cục Phát thanh, Truyền hình và Thông tin điện tử cấp ngày ngày 04/09/2025.<br>
<br>
Quyết định phát hành trò chơi điện tử G1 trên mạng số 132/QĐ-PTTH&TTĐT do Cục Phát thanh, truyền hình và thông tin điện tử cấp ngày 16/03/2026.
        </div>
        `;
    }
}
